export { PencilAlt as default } from './PencilAlt';
